import {BlockEmbed} from "./block";
import AsideTours from "./asideTours";
import AsideArticles from "./asideArticles";
import AsideWebArticles from "./asideWebArticles";

class AsideContainer extends BlockEmbed {
  
  static create(value) {
    const node = super.create(value);
    node.setAttribute('contenteditable', false);
    return node;
  }
  
  constructor(scroll, domNode, value) {
    super(scroll, domNode);
    
    const domContent = document.createElement('div');
    const domAside = document.createElement('aside');
    
    domContent.classList.add('aside-content');
    domContent.setAttribute('data-placeholder', 'Несколько строк текста с подсказкой справа');
    domContent.setAttribute('contenteditable', true);
    domContent.innerHTML = value && value.content ? value.content : '<p><br></p>';
    domNode.appendChild(domContent);
    
    domAside.setAttribute('data-placeholder', 'Примечание к тексту слева');
    domAside.setAttribute('contenteditable', true);
    domAside.innerHTML = value && value.aside ? value.aside : '';
    domNode.appendChild(domAside);
  
    const asideTours = domAside.querySelector('.aside-tours');
    if (asideTours) {
      const selected = asideTours.dataset.selected.split(',');
      const el = document.createElement('div');
      el.classList.add('aside-tours');
      
      const blockKey = selected.join(',');
      if (!AsideContainer._tourCache.get(blockKey)) {
        AsideContainer._tourCache.set(blockKey, new AsideTours(scroll, el, selected));
      }
      
      const domTours = AsideContainer._tourCache.get(blockKey);
      domTours.domNode.setAttribute('contenteditable', false);
      asideTours.replaceWith(domTours.domNode);
    }
  
    const asideArticles = domAside.querySelector('.aside-articles');
    if (asideArticles) {
      const selected = asideArticles.dataset.selected.split(',');
      const el = document.createElement('div');
      el.classList.add('aside-articles');
      
      const blockKey = selected.join(',');
      if (!AsideContainer._articleCache.get(blockKey)) {
        AsideContainer._articleCache.set(blockKey, new AsideArticles(scroll, el, selected));
      }
      
      const domTours = AsideContainer._articleCache.get(blockKey);
      domTours.domNode.setAttribute('contenteditable', false);
      asideArticles.replaceWith(domTours.domNode);
    }
  
    const asideWebArticles = domAside.querySelector('.aside-web-articles');
    if (asideWebArticles) {
      let selectedUrls = [];
      let selected = [];
      const asideWebArticlesNodes = asideWebArticles.querySelectorAll('.container-list .article-card');
      if (asideWebArticlesNodes.length) {
        asideWebArticlesNodes.forEach(function(el) {
          selected.push({
            url: el.dataset.url,
            title: el.innerText,
            image: el.querySelector('img').src
          });
          selectedUrls.push(el.dataset.url);
        });
      } else {
        asideWebArticles.childNodes.forEach(function(el) {
          selected.push(Object.assign({}, el.dataset));
          selectedUrls.push(el.dataset.url);
        });
      }
      
      const el = document.createElement('div');
      el.classList.add('aside-web-articles');
      
      const blockKey = selectedUrls.join('|');
      if (!AsideContainer._webArticleCache.get(blockKey)) {
        AsideContainer._webArticleCache.set(blockKey, new AsideWebArticles(scroll, el, selected));
      }
      
      const domTours = AsideContainer._webArticleCache.get(blockKey);
      domTours.domNode.setAttribute('contenteditable', false);
      asideWebArticles.replaceWith(domTours.domNode);
    }
  }
  
  static value(domNode) {
    return getAsideContainerValue(domNode);
  }
}

AsideContainer.blotName = 'asideContainer';
AsideContainer.tagName = 'DIV';
AsideContainer.className = 'with-aside';

class AsideCache {
  constructor() {
    this._cache = [];
  }
  
  get(key) {
    return this._cache[key];
  }
  
  set(key, value) {
    this._cache[key] = value;
  }
  
  remove(key) {
    if (this._cache[key]) {
      delete this._cache[key];
    }
  }
}


AsideContainer._tourCache = new AsideCache();
AsideContainer._articleCache = new AsideCache();
AsideContainer._webArticleCache = new AsideCache();

// AsideContainer.allowedChildren = [AsideContent, Aside];

function getAsideContainerValue(domNode) {
  let aside = domNode.querySelector('aside');
  let content = domNode.querySelector('.aside-content');
  
  if (content) {
    aside = aside.innerHTML.replace((/ {2}|\r\n|\n|\r/gm),'');
    content = content.innerHTML.replace((/ {2}|\r\n|\n|\r/gm),'');
  } else {
    const domNodeHTML = domNode.innerHTML.replace((/ {2}|\r\n|\n|\r/gm),'');
    aside = domNodeHTML.replace(/(.*?)<aside.*?>(.*?)<\/aside>(.*?)/m, '$2');
    content = domNodeHTML.replace(/<aside>.*?<\/aside>/m, '');
  }
  
  return {aside: aside, content: content};
}

function isAsideContainerEmpty(domNode) {
  const value = getAsideContainerValue(domNode);
  return !value.content && !value.aside;
}

export {getAsideContainerValue, isAsideContainerEmpty, AsideContainer as default};